/** Shared Studio reference-upload acceptance (JPEG/PNG only). */

export const STUDIO_UPLOAD_MAX_BYTES = 50 * 1024 * 1024;

const ACCEPTED_UPLOAD_MIME_TYPES = new Set(["image/jpeg", "image/png"]);

export function isAcceptedUploadFile(file: File): boolean {
  if (ACCEPTED_UPLOAD_MIME_TYPES.has(file.type)) return true;
  const ext = file.name.split(".").pop()?.toLowerCase();
  return ext === "jpg" || ext === "jpeg" || ext === "png";
}

export type StudioUploadRejection = {
  kind: "type" | "size";
  fileName: string;
  sizeBytes: number;
};

export function getUploadRejection(
  file: File,
): StudioUploadRejection | null {
  if (!isAcceptedUploadFile(file)) {
    return { kind: "type", fileName: file.name, sizeBytes: file.size };
  }
  if (file.size > STUDIO_UPLOAD_MAX_BYTES) {
    return { kind: "size", fileName: file.name, sizeBytes: file.size };
  }
  return null;
}

/** Body copy after the mono file name (leading space included where needed). */
export function uploadRejectionBodySuffix(rejection: StudioUploadRejection): string {
  if (rejection.kind === "size") {
    const n = Math.round(rejection.sizeBytes / 1048576);
    return ` is ${n} MB. The maximum is 50 MB.`;
  }
  const lastDot = rejection.fileName.lastIndexOf(".");
  const hasExt =
    lastDot > 0 && lastDot < rejection.fileName.length - 1;
  if (!hasExt) {
    return " isn't a JPG or PNG. Use a JPG or PNG side view.";
  }
  const ext = rejection.fileName.slice(lastDot + 1).toUpperCase();
  return ` is a ${ext} file. Use a JPG or PNG side view.`;
}
